'use client';

import { FC, useEffect } from 'react';

import { useLocalStorage } from '@mantine/hooks';

import { UserReferrer, UserType } from 'models';
import { UserHelpers } from 'helpers/UserHelpers';

import { useLocalEvent } from 'hooks/use-local-event';
import { SessionStorageService } from 'services/SessionStorageService';

const LocalStorageTracking: FC = () => {
    const [, setEmail] = useLocalStorage<string | undefined>({
        key: UserHelpers.localStorageKey.email,
    });

    const [, setReferrer] = useLocalStorage<UserReferrer | undefined>({
        key: UserHelpers.localStorageKey.referrer,
    });

    const [, setType] = useLocalStorage<UserType | undefined>({
        key: UserHelpers.localStorageKey.type,
    });

    const [, setUserId] = useLocalStorage<string | undefined>({
        key: UserHelpers.localStorageKey.userId,
    });

    const { setLocalEvent } = useLocalEvent();

    useEffect(() => {
        const visited = SessionStorageService.get('visited');

        if (visited) {
            return;
        }

        const query: string = window.location.search;
        const params = new URLSearchParams(query);

        const referrer = params.get('referrer') as UserReferrer | null;
        const type = params.get('type');

        const email = params.get('email');
        const event = params.get('event');
        const userId = params.get('userId');

        if (referrer && Object.values(UserReferrer).includes(referrer)) {
            setReferrer(referrer);
        } else if (window.location.toString().includes('/resourcepro')) {
            setReferrer(UserReferrer.REPLUS);
        }

        if (email) {
            setEmail(email);
        }

        if (event) {
            setLocalEvent(event);
        }

        if (UserHelpers.isUserType(type)) {
            setType(type);
        }

        if (userId) {
            setUserId(userId);
        }

        SessionStorageService.store('visited', new Date());
    }, []);

    return null;
};

export { LocalStorageTracking };
